import { toBase64 } from 'js-base64';
import { IStore } from '../reducers';

export const authTokenSelector = (state: IStore): string | undefined => {
  const authState = state.auth;

  if (authState.sessionId && authState.wallet && authState.signature) {
    const tokenObj = {
      session_id: authState.sessionId,
      wallet: authState.wallet,
      signature: authState.signature,
      network: authState.network,
    };

    const token = toBase64(JSON.stringify(tokenObj));

    return token;
  }

  return undefined;
};
